// src/components/Home.js
import React from 'react';
import '../App.css';

const QrLogo = () => (
  <svg width="300" height="200" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" y="10" width="30" height="30" fill="#2E7D32" />
    <rect x="60" y="10" width="30" height="30" fill="#2E7D32" />
    <rect x="10" y="60" width="30" height="30" fill="#2E7D32" />
    <rect x="20" y="20" width="10" height="10" fill="#F5F8F5" />
    <rect x="70" y="20" width="10" height="10" fill="#F5F8F5" />
    <rect x="20" y="70" width="10" height="10" fill="#F5F8F5" />
    <path d="M45 45H55V55H45V45Z" fill="#FFB300" />
  </svg>
);

const Home = () => (
  <section className="hero-section">
    <div className="hero-content">
      <h1 className="hero-title">Make Payments Personal</h1>
      <p className="hero-subtitle2">A personal way to transfer money to people close to you.</p>
      <p className="hero-subtitle">Personal. Instant. Human</p>
      <div className="hero-image-wrapper">
        <QrLogo />
      </div>
      <div className="app-links">
        <a href="https://apps.apple.com/zm/app/zangena/id6743426246" target="_blank" rel="noopener noreferrer" className="app-button ios">
          Download for iOS
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.zangena" target="_blank" rel="noopener noreferrer" className="app-button android">
          Download for Android
        </a>
      </div>
    </div>
  </section>
);

export default Home;